/**
 * @desc 导出
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.warehouseCost.exporting.Params, options?: any) {
  return updateResponse(
    http(URL + `/warehouseCost/export`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
